import { render, staticRenderFns } from "./subjectChoose.vue?vue&type=template&id=53a38c44&scoped=true&"
import script from "./subjectChoose.vue?vue&type=script&lang=js&"
export * from "./subjectChoose.vue?vue&type=script&lang=js&"
import style0 from "./subjectChoose.vue?vue&type=style&index=0&id=53a38c44&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a38c44",
  null
  
)

export default component.exports